/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Seg_Articles_SInputs */

const en_funnel_ob_seg_articles_s = /** @type {(inputs: Funnel_Ob_Seg_Articles_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blogs, newsletters, the web`)
};

const es_funnel_ob_seg_articles_s = /** @type {(inputs: Funnel_Ob_Seg_Articles_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blogs, newsletters, la web`)
};

/**
* | output |
* | --- |
* | "Blogs, newsletters, the web" |
*
* @param {Funnel_Ob_Seg_Articles_SInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_seg_articles_s = /** @type {((inputs?: Funnel_Ob_Seg_Articles_SInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Seg_Articles_SInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_seg_articles_s(inputs)
	return en_funnel_ob_seg_articles_s(inputs)
});